module.exports = __webpack_public_path__ + "img/inter15.bc21e616.jpg";